import React from 'react';
import NavigationMenuSuffix, {
	INavigationMenuSuffix,
} from './NavigationMenuSuffix';

interface Props {
	data: INavigationMenuSuffix[];
}

const NavigationMenuSuffixes: React.FC<Props> = ({ data }) => {
	return (
		<div className='d-flex flex-row' style={{ gap: '3px' }}>
			{data.map(item => (
				<NavigationMenuSuffix item={item} />
			))}
		</div>
	);
};

export default NavigationMenuSuffixes;
